import script from "./ObjectList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ObjectList.vue?vue&type=script&lang=ts&setup=true"

import "./ObjectList.vue?vue&type=style&index=0&id=48cb920a&lang=scss"

const __exports__ = script;

export default __exports__